import { render, staticRenderFns } from "./Intellectualproperty.vue?vue&type=template&id=0420f5a4&scoped=true&"
import script from "./Intellectualproperty.vue?vue&type=script&lang=js&"
export * from "./Intellectualproperty.vue?vue&type=script&lang=js&"
import style0 from "./Intellectualproperty.vue?vue&type=style&index=0&id=0420f5a4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0420f5a4",
  null
  
)

export default component.exports